/**
 * TUVI - GraphQL Client
 * Cliente ligero para comunicación con el API GraphQL
 */

import { GRAPHQL_URL } from '../config';

class GraphQLClient {
  constructor() {
    this.url = GRAPHQL_URL;
  }

  getToken() {
    return localStorage.getItem('tuvi_token');
  }

  async query(queryString, variables = {}) {
    const token = this.getToken();

    const headers = { 'Content-Type': 'application/json' };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(this.url, {
      method: 'POST',
      headers,
      body: JSON.stringify({ query: queryString, variables }),
    });

    const json = await response.json();

    if (json.errors) {
      const msg = json.errors[0]?.message || 'Error en la consulta';
      const error = new Error(msg);
      error.graphQLErrors = json.errors;
      throw error;
    }

    return json.data;
  }

  async mutate(mutation, variables = {}) {
    return this.query(mutation, variables);
  }
}

const client = new GraphQLClient();
export default client;
